import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'

import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import CardContent from '@material-ui/core/CardContent'
import CardActions from '@material-ui/core/CardActions'
import Divider from '@material-ui/core/Divider'

import FormControl from '@material-ui/core/FormControl'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import InputLabel from '@material-ui/core/InputLabel'
import Snackbar from '@material-ui/core/Snackbar'
import Fade from '@material-ui/core/Fade'

import { connect } from 'react-redux'

import { handleSaveEnquiry } from '../../actions/enquiries'
import { enquiryDateTypes } from '../../utils/_DATA'
import t from '../../utils/lang/enquiry'

const styles = theme => ({
  cardHeader: {
    fontWeight: '500'
  },
  formControl: {
    margin: '0 0 10px',
    width: '100%'
  },
  cardActions: {
    justifyContent: 'flex-end'
  }
});

class CardLeaseDetails extends Component {
  state = {
    leaseFTS: '',
    leaseMonthlyValue: '',
    leaseStartDate: '',
    leaseEndDate: '',
    leaseEndDateType: '',
    snackbarOpen: false
  }

  componentDidMount () {
    const { data } = this.props

    //console.log(data)

    this.setState(() => ({
      leaseFTS: data.leaseFTS,
      leaseMonthlyValue: data.leaseMonthlyValue,
      leaseStartDate: data.leaseStartDate,
      leaseEndDate: data.leaseEndDate,
      leaseEndDateType: data.leaseEndDateType
    }))
  }

  handleChangeLeaseFTS = e => {
    const leaseFTS = e.target.value

    this.setState(() => ({
      leaseFTS
    }))
  }

  handleChangeLeaseMonthlyValue = e => {
    const leaseMonthlyValue = e.target.value

    this.setState(() => ({
      leaseMonthlyValue
    }))
  }

  handleChangeLeaseStartDate = e => {
    const leaseStartDate = e.target.value

    this.setState(() => ({
      leaseStartDate
    }))
  }

  handleChangeLeaseEndDateType = e => {
    const leaseEndDateType = e.target.value

    this.setState(() => ({
      leaseEndDateType,
      leaseEndDate: '',
    }))
  }

  handleChangeLeaseEndDate = e => {
    const leaseEndDate = e.target.value

    this.setState(() => ({
      leaseEndDate
    }))
  }

  handleSaveData = e => {
    const { id, dispatch } = this.props
    const data = JSON.stringify(this.state)

    //console.log(data)

    dispatch(handleSaveEnquiry(id, data))

    this.handleOpenSnackbar()
  }

  handleOpenSnackbar = () => {
    this.setState({ snackbarOpen: true })
  }

  handleCloseSnackbar = () => {
    this.setState({ snackbarOpen: false })
  }

  render() {
    const { leaseFTS, leaseMonthlyValue, leaseStartDate, leaseEndDate, leaseEndDateType } = this.state
    const { classes } = this.props

    const lang = 'en'

    return (
      <Fragment>
        <Card style={{ marginTop: '20px' }}>
          <CardHeader
            title="Lease details"
            classes={{ title: classes.cardHeader }}
          />
          <Divider />
          <CardContent>
            <form>
              <FormControl className={classes.formControl}>
                <TextField
                  id="leaseFTS"
                  label={t[lang].leaseFTS}
                  value={leaseFTS}
                  onChange={this.handleChangeLeaseFTS}
                />
              </FormControl>
              <FormControl className={classes.formControl}>
                <TextField
                  id="leaseMonthlyValue"
                  label={t[lang].leaseMonthlyValue}
                  value={leaseMonthlyValue}
                  onChange={this.handleChangeLeaseMonthlyValue}
                />
              </FormControl>
              <FormControl className={classes.formControl}>
                <TextField
                  id="leaseStartDate"
                  label={t[lang].leaseStartDate}
                  value={leaseStartDate}
                  type="date"
                  format={'YYYY-MM-DD'}
                  onChange={this.handleChangeLeaseStartDate}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </FormControl>

              <FormControl className={classes.formControl}>
                <InputLabel htmlFor="leaseEndDateType">{t[lang].leaseEndDateType}</InputLabel>
                <Select
                  id="leaseEndDateType"
                  value={leaseEndDateType}
                  onChange={this.handleChangeLeaseEndDateType}
                  name="leaseEndDateType"
                >
                  {enquiryDateTypes['en'].map((option) => (
                    <MenuItem key={option.id} value={option.id}>{option.title}</MenuItem>
                  ))}
                </Select>
              </FormControl>

              {leaseEndDateType === '1' && (<FormControl className={classes.formControl}>
                <TextField
                  id="leaseEndDate"
                  label={t[lang].leaseEndDate}
                  value={leaseEndDate}
                  type="date"
                  format={'YYYY-MM-DD'}
                  onChange={this.handleChangeLeaseEndDate}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </FormControl>)}
            </form>
          </CardContent>
          <Divider />
          <CardActions className={classes.cardActions}>
            <Button color="primary" onClick={this.handleSaveData}>
              Save
            </Button>
          </CardActions>
        </Card>

        <Snackbar
          open={this.state.snackbarOpen}
          onClose={this.handleCloseSnackbar}
          TransitionComponent={Fade}
          ContentProps={{
            'aria-describedby': 'message-id',
          }}
          message={<span id="message-id">Lease details have been saved.</span>}
        />
      </Fragment>
    )
  }
}

CardLeaseDetails.propTypes = {
  id: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired
}

function mapStateToProps ({ authedUser }) {
  return {
    userId: authedUser.id
  }
}

export default connect(mapStateToProps)(withStyles(styles)(CardLeaseDetails))


// WEBPACK FOOTER //
// ./src/components/Enquiries/CardLeaseDetails.js